import React from 'react';
import { motion } from 'framer-motion';

const SectionHowItWorks = () => (
  <section className="py-16 bg-white">
    <div className="container mx-auto px-4">
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
        className="max-w-3xl mx-auto"
      >
        <ul className="space-y-6 text-lg">
          {[
            'Make a quick and easy application online',
            'You will then receive a call from one of our consultants who will take your application through our responsible lending assessment process.',
            'Once approved, the loan funds will be deposited into your account. Sweeet!'
          ].map((text, idx) => (
            <li className="flex items-start" key={idx}>
              <svg className="h-7 w-7 mr-4 text-secondary mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <p className="text-gray-700">{text}</p>
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  </section>
);

export default SectionHowItWorks;
